module.exports = __webpack_public_path__ + "img/q17.4fa4b98f.png";